import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '.';
import Translate from './translate';
import CSSModules from 'react-css-modules';
import style from './carousel.scss';



@CSSModules(style, { allowMultiple: true })
export default class Carousel extends Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    items: PropTypes.array,
    indicatorStyle: PropTypes.object
  }

  static defaultProps = {
    activeIndex: 0,
    items: []
  }

  state = {
    length: this.props.items.length,
    activeIndex: this.props.activeIndex || 0
  }

  goToSlide(type, index = null) {
    const { length, activeIndex } = this.state;

    if (type === 'previous') {
      if (activeIndex > 0) {
        this.setState({ activeIndex: activeIndex - 1 });
      }
    }

    if (type === 'next') {
      if (activeIndex < length - 1) {
        this.setState({ activeIndex: activeIndex + 1 });
      }
    }

    if (type === 'index') {
      this.setState({ activeIndex: index });
    }
  }

  render() {
    const { length, activeIndex } = this.state;
    const { items, indicatorStyle } = this.props;

    return (
      <div styleName="root">
        {
          items.map( (item, index) => (
            <div key={index} style={{ marginTop: '-2px' }} styleName={`item ${activeIndex === index ? 'active' : ''}`}>
              {item}
            </div>
          ))
        }
        <div styleName="indicators" style={{...indicatorStyle}}>
          <Button type="white-ghost" onClick={() => this.goToSlide('previous')} disabled={activeIndex <= 0}>{Translate.get('previous')}</Button>
          <ul>
            {
              items.map( (item, index) => (
                <li styleName={activeIndex === index ? 'active' : ''} key={index} onClick={() => this.goToSlide('index', index)}></li>
              ))
            }
          </ul>
          <Button type="white-ghost" onClick={() => this.goToSlide('next')} disabled={activeIndex >= length - 1}>{Translate.get('next')}</Button>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/carousel.js